<div class='pt-no-active-module'>
  <ng-container [ngSwitch]='primatooModule'>

    <ng-container *ngSwitchCase='PrimatooModule.CYBERSEC'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"ai.svg"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_CYBERSEC" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about CYBERSEC module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='PrimatooModule.EXTRACTION'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"extraction.png"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_EXTRACTION" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about EXTRACTION module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>


    <ng-container *ngSwitchCase='PrimatooModule.LIA'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"lia.png"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_LIA" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about LIA module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>


    <ng-container *ngSwitchCase='PrimatooModule.AI'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"ai.svg"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_AI" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about AI module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='PrimatooModule.COVID'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"covid.svg"'
          [size]='80'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_COVID" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about COVID module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='PrimatooModule.DATABREACH'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"data-breach.svg"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE_DATABREACH" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           *ngIf="email" target="_blank"
           href='mailto:{{email}}?subject=[Primatoo] Request information about DATABREACH module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>

  </ng-container>


</div>
